import { Chip, Select, MenuItem, InputLabel, FormControl } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import toastError from "../../errors/toastError";
import api from "../../services/api";

export function TagsKanbanContainer({ ticket, onStageChange }) {
    const [tags, setTags] = useState([]);
    const [negocios, setNegocios] = useState([]);
    const [selectedFunil, setSelectedFunil] = useState("");
    const [selected, setSelected] = useState("");

    useEffect(() => {
        let isMounted = true;

        const init = async () => {
            try {
                const [tagsRes, negociosRes] = await Promise.all([
                    api.get("/tags/list", { params: { kanban: 1 } }),
                    api.get("/negocios"),
                ]);
                if (!isMounted) return;

                const loadedTags = tagsRes.data || [];
                const loadedNegocios = negociosRes.data || [];
                setTags(loadedTags);
                setNegocios(loadedNegocios);

                const kanbanTag = (ticket.tags || []).find(t => t.kanban === 1);
                if (kanbanTag) {
                    setSelected(kanbanTag.id);
                    const funil = loadedNegocios.find(n =>
                        Array.isArray(n.kanbanBoards) && n.kanbanBoards.includes(kanbanTag.id)
                    );
                    if (funil) setSelectedFunil(funil.id);
                }
            } catch (err) {
                toastError(err);
            }
        };

        init();
        return () => { isMounted = false; };
    }, [ticket.tags]);

    const availableTags = (() => {
        if (!selectedFunil) return [];
        const funil = negocios.find(n => n.id === selectedFunil);
        if (!funil || !Array.isArray(funil.kanbanBoards)) return [];
        return tags.filter(t => funil.kanbanBoards.includes(t.id));
    })();

    const handleFunilChange = (e) => {
        setSelectedFunil(e.target.value);
        setSelected("");
    };

    const onChange = async (e) => {
        const value = e.target.value;
        const kanbanTags = (ticket.tags || []).filter(t => t.kanban === 1);
        for (const kt of kanbanTags) {
            await api.delete(`/ticket-tags/${ticket.id}/${kt.id}`);
        }
        if (value !== null && value !== "") {
            await api.put(`/ticket-tags/${ticket.id}/${value}`);
        }
        setSelected(value);
        if (typeof onStageChange === "function") {
            onStageChange(value);
        }
    };

    const renderSelectedTag = () => {
        const tag = tags.find(t => t.id === selected);
        if (!tag) return null;
        return (
            <Chip
                style={{
                    backgroundColor: tag.color,
                    color: "#FFF",
                    fontWeight: "bold",
                    paddingLeft: 5,
                    paddingRight: 5,
                    borderRadius: 3,
                    fontSize: "0.8em",
                    whiteSpace: "nowrap",
                }}
                label={tag.name}
                size="small"
            />
        );
    };

    const menuProps = {
        anchorOrigin: { vertical: "bottom", horizontal: "left" },
        transformOrigin: { vertical: "top", horizontal: "left" },
        getContentAnchorEl: null,
    };

    return (
        <>
            <FormControl fullWidth margin="dense" variant="outlined">
                <InputLabel id="funil-select-id">Funil</InputLabel>
                <Select
                    labelId="funil-select-id"
                    label="Funil"
                    value={selectedFunil}
                    onChange={handleFunilChange}
                    MenuProps={menuProps}
                >
                    <MenuItem value="">&nbsp;</MenuItem>
                    {negocios.map(n => (
                        <MenuItem key={n.id} value={n.id}>{n.name}</MenuItem>
                    ))}
                </Select>
            </FormControl>

            <FormControl fullWidth margin="dense" variant="outlined" disabled={!selectedFunil}>
                <InputLabel id="tag-kanban-id">Etapa Kanban</InputLabel>
                <Select
                    labelId="tag-kanban-id"
                    label="Etapa Kanban"
                    value={selected}
                    onChange={onChange}
                    MenuProps={menuProps}
                    renderValue={renderSelectedTag}
                >
                    <MenuItem value="">&nbsp;</MenuItem>
                    {availableTags.map(tag => (
                        <MenuItem key={tag.id} value={tag.id}>{tag.name}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </>
    );
}
